// extracted by mini-css-extract-plugin
export var fontItalic = "s-module--fontItalic--de8ad";
export var fontWeightBold = "s-module--fontWeightBold--84d69";
export var fontWeightExtraBold = "s-module--fontWeightExtraBold--0f09a";
export var fontWeightRegular = "s-module--fontWeightRegular--d441e";
export var fontWeightSemiBold = "s-module--fontWeightSemiBold--23510";
export var h1 = "s-module--h1--39801";
export var h2 = "s-module--h2--43937";
export var h3 = "s-module--h3--92401";
export var h4 = "s-module--h4--d5116";
export var h5 = "s-module--h5--a0039";
export var h6 = "s-module--h6--1bd02";
export var p = "s-module--p--ba3bd";
export var textCenter = "s-module--textCenter--37edf";
export var textJustify = "s-module--textJustify--45211";
export var textLeft = "s-module--textLeft--ce257";
export var textLowercase = "s-module--textLowercase--b0dd5";
export var textRight = "s-module--textRight--037ab";
export var textUppercase = "s-module--textUppercase--a4cf6";